import { render, staticRenderFns } from "./leftBottom.vue?vue&type=template&id=31e77a5c"
import script from "./leftBottom.vue?vue&type=script&lang=js"
export * from "./leftBottom.vue?vue&type=script&lang=js"
import style0 from "./leftBottom.vue?vue&type=style&index=0&id=31e77a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports